import { Building2 } from "lucide-react";
import { Vis } from "@/lib/privacy";

/** iter425 pt 22 — libellé client d'un devis / d'une réservation : Société → « RAISON SOCIALE · Nom du gérant » + icône immeuble ; sinon civilité nom prénom. */
export default function DossierClientLabel({ d, testId }) {
  const c = d.client || {};
  if (d.client_type === "societe" && d.company?.raison_sociale) {
    const gerant = [c.nom, c.prenom].filter(Boolean).join(" ");
    const n = (d.persons || []).length + 1;
    return (
      <span className="inline-flex items-center" style={{ fontSize: 12.5, color: "#ececf0", gap: 6 }} data-testid={testId} data-client-type="societe">
        <Building2 size={13} style={{ color: "#C4B5FD", flexShrink: 0 }} />
        <b style={{ textTransform: "uppercase" }}>{d.company.raison_sociale}</b>
        {gerant && <span style={{ color: "#c9c9d1" }}>· {gerant} <span style={{ fontSize: 10.5, color: "#8b8b93" }}>({d.main_role || "Gérant"})</span></span>}
        <span style={{ color: "#71717c" }}>· {n} personne{n > 1 ? "s" : ""} · <Vis testId={`${testId}-phone`}>{c.telephone}</Vis></span>
      </span>
    );
  }
  return <span style={{ fontSize: 12.5, color: "#ececf0" }} data-testid={testId}>{c.civilite} {c.nom} {c.prenom} <span style={{ color: "#71717c" }}>· <Vis testId={`${testId}-phone`}>{c.telephone}</Vis></span></span>;
}
